import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { dmsRoutes } from './dms-routes';

export const DmsRouter: FC = () => {
    return (
        <Routes>
            {dmsRoutes.map((route) =>
                route.index ? (
                    <Route key="index" index element={route.element} />
                ) : (
                    <Route key={route.path} path={route.path} element={route.element} />
                )
            )}
        </Routes>
    );
};
